    <section class="config-panel filter-panel">
      <div class="panel-header refine-header">
        <div class="refine-title">
          <svg *ngIf="uiConfig?.showHeaderIcon !== false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="4" y1="21" x2="4" y2="14"></line>
            <line x1="4" y1="10" x2="4" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12" y2="3"></line>
            <line x1="20" y1="21" x2="20" y2="16"></line>
            <line x1="20" y1="12" x2="20" y2="3"></line>
            <line x1="1" y1="14" x2="7" y2="14"></line>
            <line x1="9" y1="8" x2="15" y2="8"></line>
            <line x1="17" y1="16" x2="23" y2="16"></line>
          </svg>
          <span class="ph-title">{{ uiConfig?.title || 'Refine' }}</span>
        </div>
        <div *ngIf="uiConfig?.showRecordCount !== false" class="record-chip">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
            <path d="M21 12c0 1.7-4 3-9 3s-9-1.3-9-3"></path>
            <path d="M3 5v14c0 1.7 4 3 9 3s9-1.3 9-3V5"></path>
          </svg>
          {{ recordCount }} {{ uiConfig?.recordCountLabel || 'records' }}
        </div>
      </div>

      <div class="panel-body">
        <div class="form-row">
          <div class="form-group flex-1" *ngFor="let filter of filters">
            <div class="input-with-icon">
              <ng-container [ngSwitch]="filter.icon">
                <svg *ngSwitchCase="'tag'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V2h10l8.6 8.6a2 2 0 0 1 0 2.8z"></path>
                  <line x1="7" y1="7" x2="7.01" y2="7"></line>
                </svg>
                <svg *ngSwitchCase="'user'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="4"></circle>
                  <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.9 7.9"></path>
                </svg>
                <svg *ngSwitchDefault width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </ng-container>
              <input
                type="text"
                class="custom-input"
                [placeholder]="filter.placeholder"
                [ngModel]="values[filter.key] || ''"
                (ngModelChange)="filterChange.emit({ key: filter.key, value: $event })"
              />
            </div>
          </div>

          <button
            type="button"
            class="filter-reset-btn"
            title="Reset filters"
            aria-label="Reset filters"
            (click)="resetFilters.emit()"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 4h10.5M3 4l7 8v7l4-2v-5l1.2-1.4"></path>
              <circle cx="18" cy="6" r="4.5"></circle>
              <path d="m16.5 4.5 3 3m0-3-3 3"></path>
            </svg>
          </button>
        </div>
      </div>
    </section>
  
